<h2 class="text-center" mat-dialog-title>
  Información Menu
</h2>
<app-spinner-loading *ngIf="loading">

</app-spinner-loading>



<mat-dialog-content *ngIf="!loading" class="mat-typography row  d-flex justify-content-center">
  <p class="text-center  no-padding">Todos los productos que compres en este menú podran ser utilizados en los eventos asignados,
    clubs, bares, etc.
  </p>

  <h2 class="text-center  no-padding">Lugares Donde Utilizar</h2>


  <app-div-no-result *ngIf="!events.length"></app-div-no-result>
  <div class="  d-flex justify-content-center row mt-2 mb-2 no-padding">
    <div *ngFor="let event of events" class="  no-padding col-sm-4   mt-2 mb-2  ">

      <div class="card">
        <div class="card-top">
          <img [src]="event.image" alt="Blog Name">

          <span style="   text-align: center !important;
        width: 100%;
        position: absolute;
        BACKGROUND: #313131;
        color: white;
        border-radius: 10px 10px 0px 0px;" class="date text-center">{{event.dateStart | date : 'dd/MM/yyyy, h:mm a' :
          'GMT'}}</span>
        </div>

        <button class="col-12" (click)="moveToEvent(event.id)" style="    margin-top: -2px;" mat-raised-button
        color="primary">
        <mat-icon>confirmation_number</mat-icon> VER EVENTO
      </button>
        <!-- <div class="card-info" style="  padding: 0px 20px;">
          <h2 class="text-truncate text-center">{{event.name}}</h2>

          <p class="excerpt">{{event.desc}}</p>
        </div> -->
        <!-- <div class="mb-2 flex-row" style="  padding: 0px 20px;">
          <div class="col-12  d-flex justify-content-center">

           
          </div>
        </div> -->


      </div>

    </div>

  </div>


</mat-dialog-content>



<mat-dialog-actions align="end">

  <button mat-button type="button" (click)="closeDialog(false)">Cerrar</button>
</mat-dialog-actions>
